import { colors } from "Constants";

export const noDataContainerStyle = {
  display: "flex",
  alignItems: "center",
  flex: 1,
  margin: "0px 28px 36px 40px",
  border: `1px solid ${colors.strokeOne}`,
  borderRadius: "6px",
};
